var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNextIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4171 12.5861C20.792 12.9612 21.0026 13.4698 21.0026 14.0001C21.0026 14.5305 20.792 15.0391 20.4171 15.4141L12.3591 23.4701C12.1715 23.6576 11.9172 23.7629 11.6521 23.7629C11.3869 23.7629 11.1326 23.6576 10.9451 23.4701L10.2381 22.7631C10.0506 22.5756 9.94531 22.3213 9.94531 22.0561C9.94531 21.791 10.0506 21.5367 10.2381 21.3491L17.5881 13.9981L10.2381 6.64817C10.0506 6.46064 9.94531 6.20632 9.94531 5.94116C9.94531 5.67599 10.0506 5.42169 10.2381 5.23417L10.9451 4.52716C11.1326 4.33968 11.3869 4.23438 11.6521 4.23438C11.9172 4.23437 12.1715 4.33968 12.3591 4.52716L20.4171 12.5861Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextIcon);
export default __webpack_public_path__ + "static/media/next-icon.ff76bfd1aa8c0bf3065f7dbeee5548fc.svg";
export { ForwardRef as ReactComponent };